import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React, { useState } from "react";
import { Link, redirect, useLoaderData } from "react-router-dom";
import styled from "styled-components";

// Imported actions
import { getNotificationConfigurationLocationTypes } from "../../../actions/alert.js";

// Imported assets
import PlaceholderGraph from "../../../assets/temp/StationID_BL14820458.png";

// Imported components
import Label from "../../../components/form/Label.tsx";
import NavigationBar from "../../../components/nav/NavigationBar.tsx";

// Imported utils
import { isLoggedIn } from "../../../utils/user.js";
import { getUsaStates } from "../../../actions/geo.js";

// Styled components
const Container = styled.div`
  align-items: center;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: clamp(40px, 10vw, 80px) 0 0 0;
  position: relative;
`;

const ExportDataButton = styled(Link)`
  align-self: flex-end;
  background: var(--terbine-blue);
  border-radius: 8px;
  color: white;
  font-family: Inter, Oxygen, Roboto, sans-serif;
  font-size: clamp(14px, 2vw, 18px);
  margin: 8px;
  padding: clamp(6px, 1vw, 8px) clamp(32px, 5vw, 64px);

  &:hover {
    background: lab(from var(--terbine-blue) calc(l - 5) a b / 100);
  }
`;

const FormField = styled.div`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: clamp(2px, 0.5vw, 4px);
  justify-content: center;
  overflow: hidden;
  padding: clamp(10px, 2vw, 20px) 0px;
  position: relative;

  & .MuiInputBase-root {
    background: #ffffff;
  }
`;

// TEMP Remove when Placeholder is replaced with real graphing
const GraphContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

// TEMP Remove when Placeholder is replaced with real graphing
const PlaceholderImg = styled.img`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

const MetricBox = styled.div`
  align-items: center;
  background: var(--terbine-blue);
  border-radius: 8px;
  color: white;
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-grow: 1;
  font-family: Oxygen, Inter, Roboto, sans-serif;
  gap: clamp(4px, 1vh, 8px);
  height: clamp(100px, 15vh, 120px);
  justify-content: center;
  max-width: 25vw;
  overflow: visible;
  padding: clamp(8px, 2vh, 16px);
  position: relative;
  text-align: center;
`;

const MetricData = styled.div`
  align-self: center;
  font-size: clamp(18px, 2.5vh, 26px);
  font-weight: 500;
  line-height: clamp(22px, 3vh, 32px);
  margin: auto;
  text-align: center;
  overflow-wrap: break-word;
  width: 100%;
`;

const MetricsRow = styled.div`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: clamp(10px, 3vw, 20px);
  justify-content: space-between;
  position: relative;
`;

const MetricTitle = styled.div`
  font-size: clamp(15px, 1.8vh, 16px);
  font-weight: 400;
  line-height: clamp(16px, 2vh, 22px);
  text-align: left;
  overflow-wrap: break-word;
  width: 100%;
`;

const SectionContainer = styled.div`
  align-self: stretch;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 2vw, 16px);
  height: 100vh;
  justify-content: flex-start;
  margin-bottom: 16px;
  min-width: 320px;
  padding: 0 clamp(32px, 5vw, 100px);
  position: relative;
`;

const SectionContent = styled.div`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: clamp(15px, 3vw, 30px);
  justify-content: center;
  position: relative;
`;

const SectionHeader = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: clamp(8px, 2vw, 16px);
  justify-content: flex-start;
  margin-bottom: 16px;
  padding-top: clamp(24px, 5vh, 60px);
  position: relative;
`;

const SectionHeaderContainer = styled.div`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: clamp(10px, 3vw, 60px);
  justify-content: center;
  position: relative;
`;

const SectionTitle = styled.div`
  color: black;
  font-family: Oxygen, Inter, Roboto, sans-serif;
  font-size: clamp(20px, 4vw, 40px);
  font-weight: 700;
  line-height: clamp(28px, 5vw, 48px);
  position: relative;
  text-align: center;
  width: clamp(280px, 70vw, 520px);
`;

const UptimeTrendsContainer = styled.div`
  background: #f2f2f2;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: clamp(5px, 2vw, 10px);
  padding: clamp(10px, 3vw, 16px);
  width: 100%;
`;

// const UptimeTrendsGraphContainer = styled.div`
//   background: #ffffff;
//   display: flex;
//   flex-direction: column;
//   gap: clamp(5px, 2vw, 10px);
// `;

// const UptimeTrendsGraphHeader = styled.h1`
//   align-self: flex-start;
// `;

const UptimeTrendsHeader = styled.h1`
  align-self: flex-start;
  font-family: Oxygen, Inter, Roboto, sans-serif;
  font-size: clamp(20px, 5vw, 36px);
  font-weight: 300;
  letter-spacing: 3px;
  margin-bottom: auto;
  width: 300px;
`;

const UptimeTrendsHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: clamp(10px, 3vw, 30px);
`;

const UptimeTrendsHeaderFiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: clamp(5px, 2vw, 10px);
  justify-content: flex-end;
  margin-left: auto;
  margin-right: clamp(10px, 3vw, 40px);

  & > * {
    padding-top: 0;
  }
`;

// Example uptime percentage calc (for past year)
// µ = ((525,600−(T_outage−T_excluded))/525,600) × 100

const timeIntervalOptions = [
  {
    id: 1,
    codeName: "Year to Date",
  },
  {
    id: 2,
    codeName: "Past Year",
  },
  {
    id: 3,
    codeName: "Past Month",
  },
  {
    id: 4,
    codeName: "Past Week",
  },
  {
    id: 5,
    codeName: "Past 24 Hours",
  },
  {
    id: 6,
    codeName: "Past 12 Hours",
  },
];

// Loader for router
export const loader = async () => {
  if (!isLoggedIn()) {
    return redirect("/login");
  } else {
    const locationTypes = await getNotificationConfigurationLocationTypes();
    const usStates = await getUsaStates();

    return {
      locationTypes,
      usStates,
    };
  }
};

const DataAnalytics = () => {
  const loaderData = useLoaderData() as any;

  const [locationTypes] = useState(loaderData.locationTypes);
  const [usStates] = useState(loaderData.usStates);

  const [timeInterval, setTimeInterval] = useState(4);
  const [locationType, setLocationType] = useState(4);
  const [state, setState] = useState("");

  const handleLocationTypeChange = (e) => {
    e?.preventDefault();

    setState("");

    setLocationType(e.target.value);
  };

  return (
    <Container>
      <NavigationBar />

      <SectionContainer>
        <SectionHeaderContainer>
          <SectionHeader>
            <SectionTitle>Data Analytics</SectionTitle>
          </SectionHeader>
        </SectionHeaderContainer>

        <SectionContent>
          <MetricsRow>
            <MetricBox>
              <MetricTitle>Region Status</MetricTitle>
              <MetricData>Active</MetricData>
            </MetricBox>
            <MetricBox>
              <MetricTitle>Region Uptime</MetricTitle>
              <MetricData>94%</MetricData>
            </MetricBox>
            <MetricBox>
              <MetricTitle>Alerts Triggered</MetricTitle>
              <MetricData>5</MetricData>
            </MetricBox>
          </MetricsRow>

          <UptimeTrendsContainer>
            <UptimeTrendsHeaderContainer>
              <UptimeTrendsHeader>Uptime Trends</UptimeTrendsHeader>
              <UptimeTrendsHeaderFiltersContainer>
                <FormField style={{ flexGrow: 1 }}>
                  <Label>Time Interval</Label>
                  <FormControl sx={{ width: "200px" }}>
                    <Select
                      id="time-interval-select"
                      onChange={(e) => setTimeInterval(Number(e.target.value))}
                      size="small"
                      value={timeInterval}
                    >
                      {timeIntervalOptions &&
                        timeIntervalOptions.map((type, i) => (
                          <MenuItem
                            key={`time-interval-menu-item-${i}`}
                            value={type.id}
                          >
                            {type.codeName}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </FormField>

                <FormField style={{ flexGrow: 1 }}>
                  <Label>Location Type</Label>
                  <FormControl sx={{ width: "200px" }}>
                    <Select
                      id="location-type-select"
                      onChange={(e) => handleLocationTypeChange(e)}
                      size="small"
                      value={locationType}
                    >
                      {locationTypes &&
                        locationTypes.map((type, i) => (
                          <MenuItem
                            key={`location-type-menu-item-${i}`}
                            value={type.id}
                          >
                            {type.codeName}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </FormField>

                {locationType == 3 && (
                  <FormField style={{ flexGrow: 1 }}>
                    <Label>State</Label>
                    <FormControl sx={{ width: "200px" }}>
                      <Select
                        id="state-select"
                        onChange={(e) => setState(e.target.value)}
                        size="small"
                        value={state}
                      >
                        {usStates &&
                          usStates.map((state, i) => (
                            <MenuItem
                              key={`state-menu-item-${i}`}
                              value={state.name}
                            >
                              {state.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </FormField>
                )}
              </UptimeTrendsHeaderFiltersContainer>
            </UptimeTrendsHeaderContainer>

            <GraphContainer>
              <PlaceholderImg src={PlaceholderGraph} />
            </GraphContainer>
          </UptimeTrendsContainer>
        </SectionContent>

        <ExportDataButton target="_blank" to="/power-bi">
          Export Data
        </ExportDataButton>
      </SectionContainer>
    </Container>
  );
};

export default DataAnalytics;
